export default __webpack_public_path__ + "static/media/prev-page.709b6b09.svg";